export type SeasonKey = 'SUGARCANE_2024';

export const polygonFilterSugarcane2024 = {
	combiningOperator: 'AND',
	baseConditions: [
		{
			logicalOperator: 'IN',
			tag: {
				TagName: 'GEOFENCE',
				TagPropertyKey: 'SUGARCANE_2024_STATUS',
				value: {
					valueType: 'VALUE_TYPE_STRING',
					stringValues: ['GEOFENCING_SAVED'],
				},
			},
		},
		{
			logicalOperator: 'IN',
			tag: {
				TagName: 'GEOFENCE',
				TagPropertyKey: 'GEOFENCE_SOURCE',
				value: {
					valueType: 'VALUE_TYPE_STRING',
					stringValues: ['MAPS PORTAL'],
				},
			},
		},
	],
};

export const SUGARCANE_SEASON_CONFIG: Record<
	SeasonKey,
	{
		dataLayers: string[];
		label: string;
		suggestionLayers?: string[];
		filters: Record<string, any>;
		portalLockPropertyKey?: string;
		parentPointPropertyKey?: string;
		parentRefAttributeKey?: string;
		programNames: string[];
		geofenceFlowVersion: number;
		geofenceStatusPropertyKey: 'SUGARCANE_2024_STATUS';
		geofenceRejectionReasonsPropertyKey: 'SUGARCANE_24_REJ_REASONS';
	}
> = {
	SUGARCANE_2024: {
		dataLayers: ['FARMS-USER_FARM-SUGARCANE_24_PROGRAM_TYPE'],
		label: 'Sugarcane 2024',
		suggestionLayers: ['FARMS-SATELLITE_FARM-VILLAGE_FARM'],
		filters: {
			'FARMS-USER_FARM-SUGARCANE_24_PROGRAM_TYPE':
				polygonFilterSugarcane2024,
		},
		geofenceFlowVersion: 2,
		geofenceStatusPropertyKey: 'SUGARCANE_2024_STATUS',
		geofenceRejectionReasonsPropertyKey: 'SUGARCANE_24_REJ_REASONS',
		programNames: ['SUGARCANE_PROGRAM_24'],
	},
};

export type PotatoSeasonKey = 'POTATO_2025';
export const polygonFilterPotato2025 = {
	combiningOperator: 'AND',
	baseConditions: [
		{
			logicalOperator: 'IN',
			tag: {
				TagName: 'GEOFENCE',
				TagPropertyKey: 'POTATO_2025_STATUS',
				value: {
					valueType: 'VALUE_TYPE_STRING',
					stringValues: ['GEOFENCING_SAVED'],
				},
			},
		},
		{
			logicalOperator: 'IN',
			tag: {
				TagName: 'GEOFENCE',
				TagPropertyKey: 'GEOFENCE_SOURCE',
				value: {
					valueType: 'VALUE_TYPE_STRING',
					stringValues: ['MAPS PORTAL'],
				},
			},
		},
	],
};

export const POTATO_SEASON_CONFIG: Record<
	PotatoSeasonKey,
	{
		dataLayers: string[];
		label: string;
		suggestionLayers?: string[];
		filters: Record<string, any>;
		portalLockPropertyKey?: string;
		parentPointPropertyKey?: string;
		parentRefAttributeKey?: string;
		programNames: string[];
		geofenceFlowVersion: number;
		geofenceStatusPropertyKey: 'POTATO_2025_STATUS';
		geofenceRejectionReasonsPropertyKey: 'POTATO_25_REJ_REASONS';
	}
> = {
	POTATO_2025: {
		dataLayers: ['FARMS-USER_FARM-POTATO_25_PROGRAM_TYPE'],
		label: 'Potato 2025',
		suggestionLayers: ['FARMS-SATELLITE_FARM-VILLAGE_FARM'],
		filters: {
			'FARMS-USER_FARM-POTATO_25_PROGRAM_TYPE': polygonFilterPotato2025,
		},
		geofenceFlowVersion: 2,
		geofenceStatusPropertyKey: 'POTATO_2025_STATUS',
		geofenceRejectionReasonsPropertyKey: 'POTATO_25_REJ_REASONS',
		programNames: ['POTATO_PROGRAM_25'],
	},
};

export type PaddySeasonKey = 'PADDY_2025';

export const polygonFilterPaddy2025 = {
	combiningOperator: 'AND',
	baseConditions: [
		{
			logicalOperator: 'IN',
			tag: {
				TagName: 'GEOFENCE',
				TagPropertyKey: 'PADDY_2025_STATUS',
				value: {
					valueType: 'VALUE_TYPE_STRING',
					stringValues: ['GEOFENCING_SAVED'],
				},
			},
		},
		{
			logicalOperator: 'IN',
			tag: {
				TagName: 'GEOFENCE',
				TagPropertyKey: 'GEOFENCE_SOURCE',
				value: {
					valueType: 'VALUE_TYPE_STRING',
					stringValues: ['MAPS PORTAL'],
				},
			},
		},
	],
};

export const PADDY_SEASON_CONFIG: Record<
	PaddySeasonKey,
	{
		dataLayers: string[];
		label: string;
		suggestionLayers?: string[];
		filters: Record<string, any>;
		portalLockPropertyKey?: string;
		parentPointPropertyKey?: string;
		parentRefAttributeKey?: string;
		programNames: string[];
		geofenceFlowVersion: number;
		geofenceStatusPropertyKey: 'PADDY_2025_STATUS';
		geofenceRejectionReasonsPropertyKey: 'PADDY_25_REJ_REASONS';
	}
> = {
	PADDY_2025: {
		dataLayers: ['FARMS-USER_FARM-PADDY_25_PROGRAM_TYPE'],
		label: 'Paddy 2025',
		suggestionLayers: ['FARMS-SATELLITE_FARM-VILLAGE_FARM'],
		filters: {
			'FARMS-USER_FARM-PADDY_25_PROGRAM_TYPE': polygonFilterPaddy2025,
		},
		geofenceFlowVersion: 2,
		geofenceStatusPropertyKey: 'PADDY_2025_STATUS',
		geofenceRejectionReasonsPropertyKey: 'PADDY_25_REJ_REASONS',
		programNames: ['PADDY_PROGRAM_25'],
	},
};

export type GroudnutSeasonKey = 'GROUNDNUT_2025';

export const polygonFilterGroundnut2025 = {
	combiningOperator: 'AND',
	baseConditions: [
		{
			logicalOperator: 'IN',
			tag: {
				TagName: 'GEOFENCE',
				TagPropertyKey: 'GROUNDNUT_2025_STATUS',
				value: {
					valueType: 'VALUE_TYPE_STRING',
					stringValues: ['GEOFENCING_SAVED'],
				},
			},
		},
		{
			logicalOperator: 'IN',
			tag: {
				TagName: 'GEOFENCE',
				TagPropertyKey: 'GEOFENCE_SOURCE',
				value: {
					valueType: 'VALUE_TYPE_STRING',
					stringValues: ['MAPS PORTAL'],
				},
			},
		},
	],
};

export const GROUNDNUT_SEASON_CONFIG: Record<
	GroudnutSeasonKey,
	{
		dataLayers: string[];
		label: string;
		suggestionLayers?: string[];
		filters: Record<string, any>;
		portalLockPropertyKey?: string;
		parentPointPropertyKey?: string;
		parentRefAttributeKey?: string;
		programNames: string[];
		geofenceFlowVersion: number;
		geofenceStatusPropertyKey: 'GROUNDNUT_2025_STATUS';
		geofenceRejectionReasonsPropertyKey: 'GROUNDNUT_25_REJ_REASONS';
	}
> = {
	GROUNDNUT_2025: {
		dataLayers: ['FARMS-USER_FARM-GROUNDNUT_25_PROGRAM_TYPE'],
		label: 'Groundnut 2025',
		suggestionLayers: ['FARMS-SATELLITE_FARM-VILLAGE_FARM'],
		filters: {
			'FARMS-USER_FARM-GROUNDNUT_25_PROGRAM_TYPE':
				polygonFilterGroundnut2025,
		},
		geofenceFlowVersion: 2,
		geofenceStatusPropertyKey: 'GROUNDNUT_2025_STATUS',
		geofenceRejectionReasonsPropertyKey: 'GROUNDNUT_25_REJ_REASONS',
		programNames: ['GROUNDNUT_PROGRAM_25'],
	},
};

type SeasonConfig =
	| typeof SUGARCANE_SEASON_CONFIG
	| typeof GROUNDNUT_SEASON_CONFIG
	| typeof PADDY_SEASON_CONFIG
	| typeof POTATO_SEASON_CONFIG;

export const getConfigByType = (type: string): SeasonConfig | {} => {
	switch (type?.toLowerCase()) {
		case 'groundnut':
			return GROUNDNUT_SEASON_CONFIG;
		case 'sugarcane':
			return SUGARCANE_SEASON_CONFIG;
		case 'paddy':
			return PADDY_SEASON_CONFIG;
		case 'potato':
			return POTATO_SEASON_CONFIG;
		default:
			return {};
	}
};
